"use client";

import { FileText } from "lucide-react";
import { useState } from "react";
import { PdfPreviewModal } from "@/components/documents/pdf-preview-modal";

/** A PDF attached to a text: a link that opens the document in the shared PDF window (reader, download). */
export function PdfViewerLink({ file, name }: { file: string; name: string }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} className="inline-flex items-center gap-2 text-primary underline underline-offset-2"><FileText aria-hidden className="size-4" />{name}</button>
      <PdfPreviewModal href={file} title={name} open={open} onOpenChange={setOpen} />
    </>
  );
}
